riot.tag2('bbc-notifications-onboarding-u13', '<div class="notifications-full notifications-u13--onboarding-image"> <div class="notifications__container"> <div class="notifications-u13--close-drawer" onclick="{close}"></div> <div class="notifications-u13--content"> <div class="notifications-layout"> <div class="notifications-layout__item gel-bp-s-8/12 gel-bp-m-6/12"> <div if="{opts.idctaData.policyCheck.parentId}"> <p class="notifications-trafalgar-bold"><i1-8n>copy.under13.parentId.title</i1-8n></p> <p class="notifications-pica"><i1-8n>copy.under13.parentId.body</i1-8n></p> </div> <div if="{opts.idctaData.policyCheck.linkPending}"> <p class="notifications-trafalgar-bold"><i1-8n>copy.under13.linkPending.title</i1-8n></p> <p class="notifications-pica"><i1-8n>copy.under13.linkPending.body</i1-8n></p> </div> <div if="{opts.idctaData.policyCheck.permissionNotifications}"> <p class="notifications-trafalgar-bold"><i1-8n>copy.under13.permissionNotifications.title</i1-8n></p> <p class="notifications-pica"><i1-8n>copy.under13.permissionNotifications.body</i1-8n></p> </div> </div> </div> <div class="notifications-layout"> <div class="notifications-20/24 notifications-layout__item notifications-u13--options"> <div if="{opts.idctaData.policyCheck.parentId}"> <a href="{buttonLink}" class="notifications-u13--ok-button notifications-pica-bold"><span><i1-8n>copy.under13.parentId.button</i1-8n></span></a> </div> <div class="notifications-u13--more"> <a href="{this.moreInfoLink}" class="notifications-pica-bold"><span class="notifications-u13--info-icon"></span><i1-8n>copy.under13.moreInfo</i1-8n></a> </div> </div> </div> </div> <div class="notifications-u13--overlay"></div> </div> </div>', '', '', function(opts) {
'use strict';

var _this = this;

var config = require('../config');

this.moreInfoLink = config.env.under13s.moreInfo;

this.close = function () {
    opts.mainApp.navNotificationElement.click();
};

this.on('mount', function () {
    // Extraordinary hack to extract the upsell button link from IDCTA html
    // To be ripped out when ID updates their html responses
    if (opts.idctaData && opts.idctaData.policyCheck && opts.idctaData.policyCheck.parentId) {
        var link = opts.idctaData.html.match(/<a\s+(?:[^>]*?\s+)?href="([^"]*)"/);
        if (link[1]) {
            _this.update({ buttonLink: link[1] });
        }
    }

    if (typeof localStorage !== 'undefined') {
        localStorage.setItem('bbc-notifications-u13-pending-policy', true);
    }
});
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-onboarding-u13.tag
 ** module id = 26
 ** module chunks = 0
 **/